import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

interface FieldOption {
    value: string | number;
    name: string;
}

interface DynamicField {
    field: string;
    label: string;
    type: string;
    required?: boolean;
    options?: FieldOption[];
}

interface FormSubsection {
  id: string;
  category?: string;
  fields: DynamicField[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-dynamic-form-array-template',
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './dynamic-form-array-template.component.html',
  styleUrl: './dynamic-form-array-template.component.scss'
})
export class DynamicFormArrayTemplateComponent {
  @Input({ required: true }) formArrayName: string;
  @Input({ required: true }) formGroup: FormGroup;
  @Input({ required: true }) subsection: FormSubsection;

  @Output() removeRowEmitter = new EventEmitter();

  constructor() {}

  public get formArray(): FormArray {
    return this.formGroup.controls[this.formArrayName] as FormArray;
  }

  public removeRow(key: string, index: number): void {
    this.removeRowEmitter.emit({ key, index });
  }
}
